if (!Librarian.MyFavorite)
    Librarian.MyFavorite = {};

Librarian.MyFavorite.SaveWindow = new Class({
    Extends: Librarian.Window,
    Binds: [
        "saveFavorite", "doSave", "addCategory", "onSuccess",
        "loadFavortiesList", "onFavoritesListLoaded", "getTypeName"
    ],

    options: {
        id: "favoriteWindow",
        treeContainer: "saveFavViewCtrl",
        width: 380,
        height: 385,
        defaultName: null,
        presType: null,
        windowMode: 0,
        data: null,
        openPermissionsAfterSave: false
    },

    data: null,
    treeView: null,
    createCatWindow: null,
    createPackage: null,
    request: null,
    favoritesList: {},
    favoriteRequest: null,
    langPrefix: "favorite",
    /*onCreated*/
    /*onCatCreated*/

    initialize: function(options) {
        this.setOptions(options);

        this.data = options.data;
        this.options.data = null;

        // If we weren't given a type, default to normal My Favorites
        if (typeof this.options.presType != "number") {
            if (this.data && (typeof this.data.prestype == "number"))
                this.options.presType = this.data.prestype;
            else
                this.options.presType = Librarian.virtPresType.myFavorite;
        }


        // Use the SlideShow translations for slide shows
        if ((this.options.presType == Librarian.virtPresType.slideshow) || (this.options.presType == Librarian.virtPresType.sharedSlideshow))
            this.langPrefix = "slideshow";
        else if (this.options.presType == Librarian.virtPresType.sharedFavorite)
            this.langPrefix = "sharedfavorite";

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString(this.langPrefix + '_' + this.getTypeName());

        // Set the content location
        if (Librarian.saveFavorite.fromLibrary)
            this.options.contentURL = Librarian.path.getLibraryPath();
        else
            this.options.contentURL = Librarian.path.getLayoutsPath() + "core/favorites/";
        this.options.contentURL += Librarian.saveFavorite.pageName;

        // Load the list of favorites so that the user knows that they are about to overwrite one
        this.loadFavortiesList();

        this.parent(this.options);
    },

    reset: function() {
        var contEl = this.getElement(this.options.treeContainer);
        if (!contEl)
            return;

        // Empty the tree container so we don't get duplicates
        contEl.empty();

        var options = {
            container: contEl.id,
            method: "getvpcc",
            rootMethod: "getvpci",
            cookieStorage: false,
            catType: Librarian.catType.myFavorite,
            // Send type parameter
            params: {
                type: this.options.presType
            }
        };

        if (typeof Library.getTreeOptions == "function")
            options = Library.getTreeOptions(options);

        this.treeView = new Librarian.TreeView(options);
        this.treeView.addEvent("select", function(node) {
            if (!node || !node.type.contains("file"))
                return;

            Librarian.Utils.setElementValue(this.getElement("myFavName"), node.name);
        }.bind(this));
        this.treeView.load();
    },

    loadFavortiesList: function() {
        this.favoriteRequest = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getvps") + "&all=1&out=dgrid&type=" + this.options.presType,
            onSuccess: this.onFavoritesListLoaded,
            onFailure: Librarian.Utils.onFailure
        });
        this.favoriteRequest.send();
    },

    onFavoritesListLoaded: function(json) {
        if (!json || !json.data || (json.data.length == 0) || !json.data[0].presentations || (json.data[0].presentations.length == 0))
            return;

        var items = json.data[0].presentations;
        for (var i = 0; i < items.length; i++)
            this.favoritesList[items[i].name.trim()] = items[i].presid;
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var type = this.getTypeName(),
            itemEl = this.getElement("saveSubmit");
        // Add the onClick and the correct label for the "save" button
        if (itemEl) {
            itemEl.addOnClick(this.saveFavorite);
            itemEl.set("text", Librarian.Lang.getString(type).toCapitalCase());
        }

        itemEl = this.getElement("addCategory");
        if (itemEl) {
            itemEl.set("text", Librarian.Lang.getString("add_category"));
            if (!Librarian.saveFavorite.allowAddCategory)
                itemEl.destroy();
            else
                itemEl.addOnClick(this.addCategory);
        }

        itemEl = this.getElement("saveCancel");
        // If the cancel button is there, add the onclick method
        if (itemEl)
            itemEl.addOnClick(this.close);

        var needsName = ((this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.save) || (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.clone)),
            contHeight = 0;
        // If this isn't a clone or a save, don't let the user change the name or description of the favorite
        if (!needsName) {
            itemEl = this.getElement("favoriteInfoContainer");
            if (itemEl) {
                contHeight = itemEl.getHeight();
                itemEl.destroy();
            }
        }
        else {
            // Update the name and description labels
            this.getElement("favoriteNameLabel").set("text", Librarian.Lang.getString(this.langPrefix + '_' + type + "_name_label"));
            this.getElement("favoriteDescrLabel").set("text", Librarian.Lang.getString(this.langPrefix + '_' + type + "_descr_label"));

            itemEl = this.getElement("myFavName");
            if (itemEl) {
                var name = null;
                // If we're given a default name, use that
                if (this.options.defaultName != null)
                    name = this.options.defaultName;
                // Otherwise try to use the name we already have
                if (this.data && (name == null))
                    name = this.data.name;
                // If we have a name to show, do it
                if (name != null)
                    Librarian.Utils.setElementValue(itemEl, name);

                // Focus the name box so that it's convenient for the user
                if (itemEl.isVisible())
                    itemEl.focus();
            }

            // Set the description if we have one
            if (this.data && (typeof this.data.description == "string"))
                Librarian.Utils.setElementValue(this.getElement("myFavDescription"), this.data.description);
        }

        // Update the save location label
        var saveToName = Librarian.Lang.getString(this.langPrefix + "_location_label");
        if (saveToName != this.langPrefix + "_location_label")
            Librarian.Utils.setElementValue(this.getElement("favoriteSaveLocation"), saveToName);

        itemEl = this.getElement("favSize");
        if (itemEl) {
            this.options.width = itemEl.width.value.toInt();
            this.options.height = itemEl.height.value.toInt() - contHeight;

            // Then resize the window
            this.resize({
                width: this.options.width,
                height: this.options.height,
                centered: false
            });
        }
        else if (contHeight > 0) {
            this.options.height -= contHeight;

            // Then resize the window
            this.resize({
                width: this.options.width,
                height: this.options.height,
                centered: false
            });
        }

        this.reset();
    },

    saveFavorite: function() {
        // Start with no selected element
        var selected = null;
        // If we are using the tree, get the selected node
        if (this.treeView)
            selected = this.treeView.getSelected();

        // Default to the root category
        var id = 0;
        if (!selected && this.treeView)
            selected = this.treeView.root;
        // If there was a selected node in the tree, get the catid from it
        if (selected)
            id = selected.data.catid;

        // If there is a valid cat ID override, use that ID instead
        var itemEl = this.getElement("userCustomCatID");
        if (itemEl && itemEl.checked && itemEl.getAttribute("catid"))
            id = itemEl.getAttribute("catid").toInt();

        var name = (Librarian.Utils.getElementValue(this.getElement("myFavName")) || '').trim(),
            needsName = ((this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.save) || (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.clone));
        if (needsName && (name.length == 0)) {
            Librarian.Utils.error(Librarian.Lang.getString(this.langPrefix + "_presnamerequired"));
            return;
        }

        // If our list of favorites already has this name, warn the user and let them decide whether they want to overwrite
        if ((this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.save) && (typeof this.favoritesList[name] == "number")) {
            var confirm = new Librarian.ConfirmWindow({
                id: "overwriteFavoriteConfirmWindow",
                title: Librarian.Lang.getString(this.langPrefix + "_overwrite"),
                question: Librarian.Lang.getString(this.langPrefix + "_overwrite?")
            });
            confirm.onFirstButtonClicked = function() {
                this.doSave(name, id, true, this.favoritesList[name]);
            }.bind(this);
            confirm.show();
        }
        else
            this.doSave(name, id);
    },

    doSave: function(name, catid, overwrite, presId) {
        var description = (Librarian.Utils.getElementValue(this.getElement("myFavDescription")) || '').trim();
        var saveEl = this.getElement("saveSubmit");
        saveEl.set("disabled", true);

        if (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.save) {
            var itemEl = this.getElement("downloadFav"),
                data = {
                    catid: catid,
                    name: name,
                    description: description,
                    params: { type: this.options.presType },
                    save: true
                },
                useCart = true;
            if (itemEl && itemEl.checked)
                data.create = true;

            this.createPackage = new Librarian.CreatePackage({
                onSuccess: function(json) {
                    if (overwrite === true) {
                        if (Librarian.userCart && useCart && (presId > 0)) {
                            for (var i = 0, length = Librarian.userCart.cartItems.items.length; i < length; i++) {
                                // Save any source-file related information before we convert the rest to a VP
                                if (!Librarian.userCart.cartItems.items[i].pagecount)
                                    Librarian.userCart.cartItems.items[i].pagecount = Librarian.userCart.cartItems.items[i].slidecount;
                                if (!Librarian.userCart.cartItems.items[i].sourceext)
                                    Librarian.userCart.cartItems.items[i].sourceext = Librarian.userCart.cartItems.items[i].ext || Librarian.userCart.cartItems.items[i].filetypeextension;

                                // CLN-2704 - Overwrite existing data with newly overwritten VP information
                                // This is to avoid problems caused by adding or reordering slides into a VP and then overwriting it, causing the thumbnails to be wrong in the cart
                                Librarian.userCart.cartItems.items[i].slidecount = length;
                                Librarian.userCart.cartItems.items[i].presid = presId;
                                Librarian.userCart.cartItems.items[i].itemnumber = (i + 1);
                                Librarian.userCart.cartItems.items[i].prestype = this.options.presType;
                                Librarian.userCart.cartItems.items[i].name = name;
                                Librarian.userCart.cartItems.items[i].catType = Librarian.catType.myFavorite;
                                Librarian.userCart.cartItems.items[i].filetypeextension = Librarian.userCart.cartItems.items[i].ext = "vpres";
                            }
                        }

                        // If we're overwriting, update the cache ID so the old thumbnails don't get shown still
                        Librarian.cacheId = Librarian.path.getUrlLibraryName() + '-' + (new Date().getTime());
                        // Reload all the thumbnails so they load fresh
                        Librarian.Utils.reloadThumbnails();
                    }
                    this.onSuccess(json, catid);
                }.bind(this)
            });

            // If we have a data override, pass the vital information along to the create
            if (this.data) {
                if (this.data.presid > 0) {
                    data.presid = this.data.presid;
                    useCart = false;
                }
                else if (this.data.groupid > 0) {
                    data.groupid = this.data.groupid;
                    useCart = false;
                }
                else if (this.data.fileid > 0) {
                    data.fileid = this.data.fileid;
                    useCart = false;
                }
                else if (this.data.data) {
                    data.items = this.data.data;
                    useCart = false;
                }
            }

            this.createPackage.send(null, data, useCart);
        }
        else {
            var method = "vpcp",
                params = "&destcid=" + catid + "&out=cjson";
            if (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.clone) {
                method = "vpcn";
                params += "&descr=" + encodeURIComponent(description) + "&name=" + encodeURIComponent(name);
            }
            else if (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.move) {
                method = "vpmv";
                params += "&srccid=" + this.data.catid;

                if (catid == this.data.catid) {
                    Librarian.Utils.error(Librarian.Lang.getString(this.langPrefix + "_same_category"));
                    return;
                }
            }

            if (this.data)
                params += "&pid=" + this.data.presid;

            this.request = new Librarian.Request.JSON({
                url: Librarian.path.getUpdateUrl(method) + params,
                onSuccess: this.onSuccess,
                onFailure: Librarian.Utils.onFailure
            });
            this.request.send();
        }
    },

    onSuccess: function(json, catid) {
        if (typeof this.onCreated == "function")
            this.onCreated(json);

        // If this is a "Save" or a "Clone"
        if ((this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.save) || (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.clone)) {
            // Open the designer for saved slideshows
            if (json && json.data && (json.data.length > 0) && ((this.options.presType == Librarian.virtPresType.slideshow) || (this.options.presType == Librarian.virtPresType.sharedSlideshow))) {
                var data = json.data[0];
                if ((typeof data.catid != "number") || (typeof data.catid != "string"))
                    data.catid = catid;
                Librarian.Utils.openSlideShow(data, "designer");
            }

            // Only clear the cart here this is a save
            if ((this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.save) &&
                // and if the create window isn't open
                (!Librarian.cartWindow || !Librarian.cartWindow.createPackage || !Librarian.cartWindow.createPackage.window) && (Librarian.cart.clearCartOnDownload || Librarian.saveFavorite.clearCart)) {
                Librarian.Cart.doClear(false);

                if (Librarian.cart.closeCartOnClear && Librarian.cartWindow)
                    Librarian.cartWindow.close();
            }
        }
        else {
            var type = Librarian.Lang.getString(this.getTypeName()).toCapitalCase();
            Librarian.Utils.notification(Librarian.Lang.getArgString("successful", type));
        }

        if (this.options.openPermissionsAfterSave && json && json.data) {
            if (this.options.presType == Librarian.virtPresType.sharedFavorite) {
                new Librarian.MyFavorite.PermissionWindow({
                    itemData: json.data[0]
                }).show();
            }
        }

        if (this.options.windowMode === Librarian.MyFavorite.SaveWindow.windowModes.save && this.onSave != null) {
            this.onSave.call(this, json);
        }

        this.close();
    },

    addCategory: function() {
        if (!this.treeView)
            return;

        var selected = this.treeView.getSelected(),
            parentId = 0;

        // If a file was selected get its parent category
        if (selected && (selected.type == "file"))
            selected = selected.parentNode;

        if (!selected)
            selected = this.treeView.root;

        if (selected)
            parentId = selected.id;

        this.createCatWindow = new Librarian.CreateCategoryWindow({
            url: Librarian.path.getUpdateUrl("vpccr"),
            parentCatId: parentId,
            params: {
                type: this.options.presType
            },
            onComplete: function() {
                this.reset();

                if (typeof this.onCatCreated == "function")
                    this.onCatCreated();
            }.bind(this)
        });
    },

    getTypeName: function() {
        if (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.clone)
            return "clone";
        else if (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.copy)
            return "copy";
        else if (this.options.windowMode == Librarian.MyFavorite.SaveWindow.windowModes.move)
            return "move";
        return "save";
    },

    onClose: function() {
        this.parent();

        var contEl = this.getElement(this.options.treeContainer);
        if (contEl)
            contEl.destroy();

        this.favoritesList = {};

        if (this.favoriteRequest) {
            this.favoriteRequest.cancel();
            this.favoriteRequest = null;
        }

        if (this.request) {
            this.request.cancel();
            this.request = null;
        }

        if (this.createCatWindow) {
            this.createCatWindow.close();
            this.createCatWindow = null;
        }

        if (this.createPackage && this.createPackage.confirm) {
            this.createPackage.confirm.close();
            this.createPackage.confirm = null;
        }
    }
});


Librarian.MyFavorite.SaveWindow.extend({
    windowModes: {
        save: 0,
        clone: 1,
        copy: 2,
        move: 3
    }
});